import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PlanTile from './PlanTile.jsx';
import PlanIntervalToggleBar from './PlanIntervalToggleBar.jsx';

class PlanSelector extends Component {
  renderPlanTiles = plans => plans.map(plan => (
    <PlanTile
      key={plan.id}
      name={plan.name}
      price={plan.price}
      effectiveMonthlyPrice={plan.effective_monthly_price}
      interval={plan.interval}
      currency={plan.currency}
      features={plan.features}
      selected={this.isPlanSelected(plan)}
      onSelect={() => this.handlePlanSelect(plan)}
    />
  ));

  handlePlanSelect = plan => this.props.onPlanSelect(plan);

  handlePlanIntervalChange = interval => this.props.onPlanIntervalChange(interval);

  isPlanSelected = plan => (plan.id === this.props.selectedPlanId);

  orderedPlans = () => this.props.plans.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));

  render() {
    const { availablePlanIntervals, selectedPlanInterval } = this.props;

    return (
      <div>
        { availablePlanIntervals.length > 1 ? (
          <PlanIntervalToggleBar
            intervals={availablePlanIntervals}
            selectedPlanInterval={selectedPlanInterval}
            onPlanIntervalChange={this.handlePlanIntervalChange} />) : null }
        {this.renderPlanTiles(this.orderedPlans())}
      </div>
    );
  }
}

PlanSelector.propTypes = {
  plans: PropTypes.array.isRequired,
  availablePlanIntervals: PropTypes.array.isRequired,
  selectedPlanInterval: PropTypes.string.isRequired,
  selectedPlanId: PropTypes.number,
  onPlanSelect: PropTypes.func.isRequired,
  onPlanIntervalChange: PropTypes.func.isRequired,
};

export default PlanSelector;